
export const FETCH_DEPARTMENTS = 'FETCH_DEPARTMENTS'
export const FETCH_DEPARTMENT = 'FETCH_DEPARTMENT'
export const FETCH_PLANS = 'FETCH_PLANS'
export const CREATE_DEPARTMENT = 'CREATE_DEPARTMENT'
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT'
export const EDIT_DEPARTMENT = 'EDIT_DEPARTMENT'
export const FETCH_DEPARTMENTS_SEARCH_SUGGESTIONS = 'FETCH_DEPARTMENTS_SEARCH_SUGGESTIONS'
export const FETCH_DEPARTMENTS_META = 'FETCH_DEPARTMENTS_META'
export const FETCH_DEPARTMENT_PAYMENT_LOGS = 'FETCH_DEPARTMENT_PAYMENT_LOGS'
export const CHARGE_DEPARTMENT_DEBT = 'CHARGE_DEPARTMENT_DEBT'
export const PAY_AMOUNT_FOR_SHIPMENTS = 'PAY_AMOUNT_FOR_SHIPMENTS'
export const FETCH_CURRENCIES = 'FETCH_CURRENCIES'
export const FETCH_DEPARTMENT_ADDRESSES = 'FETCH_DEPARTMENT_ADDRESSES'

export const CREATE_ADDRESS = 'CREATE_ADDRESS'
export const EDIT_ADDRESS = 'EDIT_ADDRESS'
export const DELETE_ADDRESS = 'DELETE_ADDRESS'
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES'

// VACATIONS
export const FETCH_DEPARTMENT_VACATION = 'FETCH_DEPARTMENT_VACATION'
export const FETCH_LAST_DEPARTMENT_VACATION = 'FETCH_LAST_DEPARTMENT_VACATION'
export const CREATE_DEPARTMENT_VACATION = 'CREATE_DEPARTMENT_VACATION'
export const EDIT_DEPARTMENT_VACATION = 'EDIT_DEPARTMENT_VACATION'
export const DELETE_DEPARTMENT_VACATION = 'DELETE_DEPARTMENT_VACATION'
export const START_EARLY_DEPARTMENT_VACATION = 'START_EARLY_DEPARTMENT_VACATION'
export const END_EARLY_DEPARTMENT_VACATION = 'END_EARLY_DEPARTMENT_VACATION'

// PARTNERSHIPS
export const FETCH_PARTNERSHIPS = 'FETCH_PARTNERSHIPS'
export const CREATE_PARTNERSHIP = 'CREATE_PARTNERSHIP'
export const EDIT_PARTNERSHIP = 'EDIT_PARTNERSHIP'

